module.exports = __webpack_public_path__ + "img/betgames_online.572b6c70.png";